import Entity from "./entity";

class DeliveryNote extends Entity {
  constructor(data) {
    super(data);
    this.date = this.convertDate(data.date);
  }
}

export default DeliveryNote;



// WEBPACK FOOTER //
// ./client/domain/deliveryNote.js